import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso,ExportComptabilite} from '@gull'

const ExportTiersCompta = (props) => {
    const t = useTranslate();

    return(
        <div className='row'>
            <div className="col-6">
                <CardPerso header={t('thirdPartyExport')}>
                    <div className='row'>
                        <div className="col-8 offset-2">
                            <div className="row">
                                <ExportComptabilite 
                                    axiosMethod='post' 
                                    title={t('thirdPartyExport')} 
                                    type="button" 
                                    url={'api/compta/sage/export_tiers'}
                                ></ExportComptabilite>
                            </div>
                        </div>
                    </div>
                </CardPerso>
            </div>
        </div>
    )
}

export default ExportTiersCompta;